import { Component, DestroyRef, inject, signal } from '@angular/core';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { KorviuButtonComponent } from 'shared/components/korviu-button/korviu-button.component';
import { PaymentAccountsService } from 'core/services/payment-accounts.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { KorviuLoaderComponent } from 'shared/components/korviu-loader/korviu-loader.component';

@Component({
  selector: 'app-remove-account-modal',
  standalone: true,
  imports: [NzModalModule, NzIconModule, KorviuButtonComponent, TranslateModule, KorviuLoaderComponent],
  templateUrl: './remove-account-modal.component.html',
  styleUrl: './remove-account-modal.component.scss'
})
export class RemoveAccountModalComponent {
  private _paymentAccountsService = inject(PaymentAccountsService);
  private _modal = inject(NzModalRef);
  public modalData = inject(NZ_MODAL_DATA);
  private _destroyRef = inject(DestroyRef);

  public isLoading = signal<boolean>(false);

  public onCancelClick(): void {
    this._modal.destroy();
  }

  public onRemoveClick(): void {
    this.isLoading.set(true);
    this._paymentAccountsService
      .removePaymentAccount(this.modalData?.id)
      .pipe(
        tap(() => {
          this._modal.destroy(true);
        }),
        finalize(() => {
          this.isLoading.set(false);
        }),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe();
  }
}
